/**
 * The IOS - Apple itunes fetch reviews API url.
 * @type {String}
 */
export const IOS_FETCH_REVIEWS_API = 'https://itunes.apple.com/lookup?id=346080608';
